var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.1406H0V15.9597H20V14.1406Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00977 11.0095V12.9286H18.9897V11.0095C18.9897 6.42493 15.5545 2.58573 10.9982 2.07969L10.9093 2.06858V0H9.09017V2.06858L9.00128 2.07969C4.44495 2.58674 1.00977 6.42594 1.00977 11.0095ZM9.99921 3.8392C13.9536 3.8392 17.1706 7.05621 17.1706 11.0106V11.1106H2.82887V11.0095C2.82887 7.0552 6.04486 3.8392 9.99921 3.8392Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.dc6e998da3f3f109493a0828f33f2718.svg";
export { ForwardRef as ReactComponent };